import { createEntityCollectionStore, ngrxEvent } from '@core/ngrx-legacy';
import { TellentGroup, TellentGroupKind } from '@core/tellent-types';

import { GroupsParams } from './tellent-groups.types';

const idSelector = ({ guid }: { guid: string }) => guid;

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TellentGroup>()(
  'TellentGroups',
  {
    customActions: adapter => ({
      fetchPaginatedCollection: (state, payload: { params: GroupsParams }) =>
        adapter.markAsPending(state, { scope: payload.params.scope, entities: [] }),

      addNew: ngrxEvent<{
        name: string;
        translations: Array<{ langCode: string; name: string }>;
        kind: TellentGroupKind;
      }>(),
      addNewSuccess: (state, payload: { data: TellentGroup }) =>
        adapter.addOne(state, payload.data),
      addNewFailed: (state, payload: { errors: { [fieldKey: string]: string[] } }) => state,

      editGroup: ngrxEvent<{
        name: string;
        guid: string;
        translations: Array<{ langCode: string; name: string }>;
      }>(),
      editGroupSuccess: (state, payload: { data: TellentGroup }) =>
        adapter.updateOne(state, payload.data),
      editGroupFailed: (state, payload: { errors: { [fieldKey: string]: string[] } }) => state,

      removeGroup: ngrxEvent<{ guid: string }>(),
      removeGroupSuccess: ngrxEvent<void>(),
      removeGroupFailed: (state, payload: { error: string }) => state,

      addMembers: ngrxEvent<{ groupGuid: string; membersGuids: string[] }>(),
      addMembersSuccess: (state, payload: { data: TellentGroup }) =>
        adapter.updateOne(state, payload.data),
      addMembersFailed: (state, payload: { error: string }) => state,

      removeMembers: ngrxEvent<{ groupGuid: string; membersGuids: string[] }>(),
      removeMembersSuccess: (state, payload: { data: TellentGroup }) =>
        adapter.updateOne(state, payload.data),
      removeMembersFailed: (state, payload: { error: string }) => state,
    }),
    idSelector,
  },
);

const TellentGroupsActions: Pick<
  typeof actions,
  | 'fetchPaginatedCollection'
  | 'fetchPaginatedCollectionSuccess'
  | 'fetchPaginatedCollectionFailed'
  | 'fetchOne'
  | 'fetchOneSuccess'
  | 'fetchOneFailed'
  | 'addNew'
  | 'addNewSuccess'
  | 'addNewFailed'
  | 'removeGroup'
  | 'removeGroupSuccess'
  | 'removeGroupFailed'
  | 'addMembers'
  | 'addMembersSuccess'
  | 'addMembersFailed'
  | 'removeMembers'
  | 'removeMembersSuccess'
  | 'removeMembersFailed'
  | 'editGroup'
  | 'editGroupSuccess'
  | 'editGroupFailed'
> = actions;

const TellentGroupsSelectors: Pick<
  typeof selectors,
  'entities' | 'pagination' | 'isPending' | 'isLoaded' | 'byId'
> = selectors;

export {
  reducer as TellentGroupsReducer,
  namespace as TellentGroupsNamespace,
  TellentGroupsActions,
  TellentGroupsSelectors,
};
